import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/not-authorized")({
  component: NotAuthorizedPage,
});

function NotAuthorizedPage() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-6 px-6 text-center">
      <h1 className="font-serif text-3xl font-semibold tracking-tight">
        Not authorized
      </h1>
      <p className="text-muted-foreground">
        This Google account isn't on the household allowlist. If this is a
        mistake, ask the family member who set up Hearth to add your email.
      </p>
      <Link
        to="/sign-in"
        className="text-sm font-medium text-primary underline-offset-4 hover:underline"
      >
        Try a different account
      </Link>
    </div>
  );
}
